import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsDropdownModule } from 'ngx-bootstrap';
import { BlNgUiComponentModule } from '@blcloud/bl-ng-ui-component';
import { OrgMasterSelectSearchComponent } from './org-master-select-search.component';

/**
 * 失注理由・コンタクト区分の2列UI（コンタクト一覧・初期表示設定モジュールで共用）
 * ContactListPageService は親コンポーネントの providers から注入する
 */
@NgModule({
  imports: [
    CommonModule,
    BlNgUiComponentModule,
    BsDropdownModule.forRoot(),
  ],
  declarations: [
    OrgMasterSelectSearchComponent,
  ],
  exports: [
    OrgMasterSelectSearchComponent,
  ],
})
export class OrgMasterSelectSearchModule { }



// WEBPACK FOOTER //
// ./src/app/page/contact-list-page/org-master-select-search/org-master-select-search.module.ts